var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('individual-contact-edit',{ref:"contact",attrs:{"contact":_vm.copyOrg},on:{"addRow":_vm.addRow,"remove":_vm.removeEntry,"tagSelect":_vm.onTagSelect,"addRowAddress":_vm.addRowAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }